
<!--
  ~ VNCcontact+ : A new level of contact management
  ~ Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
  ~
  ~ This program is free software: you can redistribute it and/or modify
  ~ it under the terms of the GNU Affero General Public License as published by
  ~ the Free Software Foundation, version 3 of the License.
  ~
  ~ This program is distributed in the hope that it will be useful,
  ~ but WITHOUT ANY WARRANTY; without even the implied warranty of
  ~ MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
  ~ GNU Affero General Public License for more details.
  ~
  ~ You should have received a copy of the GNU Affero General Public License
  ~ along with this program. Look for COPYING file in the top folder.
  ~ If not, see http://www.gnu.org/licenses/.
  -->

<div>
    <div class="content">
        <div class="message">
            {{ 'CONTACT_SEARCH_NAME' | translate }}
        </div>
        <div class="content">
            <mat-form-field>
                <input [(ngModel)]="saveSearchTitle" #saveSearchInput matInput autocomplete="off" autocorrect="off"
                    autocapitalize="off" spellcheck="false">
            </mat-form-field>
        </div>
        <div class="actions">
            <a id="mobile_Sidebar_createfolder_cancelbtn" class="cancel-btn" (click)="closeDialog()">{{ 'CANCEL' | translate }}</a>
            <a id="mobile_Sidebar_createfolder_createbrn" [class.action-disabled]="saveSearchTitle.length < 1"
                (click)="createSaveSearch()">{{ 'CREATE' | translate }}</a>
        </div>
    </div>
</div>